// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__aOmNj","header":"App_header__2MS2l","logo":"App_logo__2loz0","mainContent":"App_mainContent__PKUFJ"};